if (!customElements.get('paw-story-slider')) {
  customElements.define(
    'paw-story-slider',
    class PawStorySlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.paw-story__slide'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.counter = this.querySelector('[data-current]');
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1));

        // Theme editor: show the slide whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) this.go(i);
        });
      }

      go(i) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        if (this.counter) this.counter.textContent = this.index + 1;
      }
    }
  );
}
